import useAPI from "@/services/api/hook";

// What esignconnector says about the account's e-sign connection.
export enum EsignConnectionState {
  NOT_CONNECTED = "not_connected",
  CONNECTED = "connected",
  // The key stopped working, so Send and status tracking wait for a new one.
  NEEDS_RECONNECT = "needs_reconnect"
}

export interface EsignConnectionStatus {
  state: EsignConnectionState;
  vendor: string | null;
  connectedAs: string | null;
  stateSince: string | null;
  // Reps whose email matches a user in the vendor's workspace; only they can send.
  matchedUserIds: string[];
  unmatchedUserIds: string[];
}

export const ESIGN_CONNECTION_QUERY = "esignconnector/connection";

export const useEsignConnection = (enabled: boolean) =>
  useAPI(ESIGN_CONNECTION_QUERY, { method: "GET" }, { enabled });
